module.exports = __webpack_public_path__ + "static/man-on-beach-8e473a730113453835d916d24c1583a2.jpg";